const baseColors = {
  darkerGray: '#34353c',
  darkGray: '#7e838f',
  gray: '#c5cad6',
  lightGray: '#e9f0f4',
  lighterGray: '#f5f9fb',
  darkerGold: '#961370',
  darkGold: '#946629',
  gold: '#ad8753',
  lightGold: '#ae9576',
  lighterGold: '#f1eae2',
  darkGreen: '#045443',
  green: '#106b57',
  lightGreen: '#317868',
  lighterGreen: '#87b5ab',
  darkerGrayTint: 'rgba(1, 3, 11, 0.8)',
  darkGrayTint: 'rgba(65,72,89,0.68)',
  grayTint: 'rgba(139,149,173,0.5)',
  lightGrayTint: 'rgba(212, 226, 234, 0.5)',
  lighterGrayTint: 'rgba(233, 243, 247, 0.47)',
  black: '#000000',
  white: '#ffffff',
  grey: '#7e838f',
  red: '#db2f23',
  error: '#db2f23'
};

export const colors = {
  ...baseColors,
  primary: baseColors.darkerGray,
  secondary: baseColors.lightGray,
  text: baseColors.darkerGray,
  lightText: baseColors.darkGray,
  placeHolder: baseColors.lightGreen,
  backgroundLight: 'f5f9fb',
  background: '#e9f0f4',
  grey: ['#34353c', '#9ba3af', '#7e838f', '#b4bec8'],
  blue: ['#e9f0f4', '#c9d3dc', '#f5f9fb'],
  white: baseColors.white,
  black: baseColors.black
};

export const breakpoints = ['767px', '1023px', '1130px'];

const theme = {
  fontSizes: [13, 15, 17, 34, 48, 64, 96, 128],
  space: [0, 4, 8, 12, 16, 24, 32, 64, 128, 256],
  breakpoints,
  colors: {
    ...colors
  },
  buttons: {
    primary: {
      color: colors.white,
      backgroundColor: colors.green
    },
    secondary: {
      color: colors.primary,
      backgroundColor: colors.secondary
    }
  },
  buttonSizes: {
    small: {
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 5,
      paddingBottom: 5,
      borderRadius: 16
    },
    medium: {
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 13,
      paddingBottom: 13
    }
  },
  cButtonSizes: {
    small: {
      width: 52,
      height: 52,
      padding: 0,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    medium: {
      width: 80,
      height: 80,
      padding: 6,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    large: {
      width: 104,
      height: 104,
      padding: 8,
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexDirection: 'column'
    }
  },
  cfButtonSizes: {
    small: {
      width: 26,
      height: 52,
      padding: 0,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    medium: {
      width: 40,
      height: 80,
      padding: 6,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    large: {
      width: 52,
      height: 104,
      padding: 8,
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexDirection: 'column'
    }
  }
};

export default theme;
